import React from 'react';
import '../../../styles/desktop/sobre.css';

const CopyrightComponent = ({ onClose }) => {
  return (
    <div className="container-cp">
      <button className="sobre-back-button" onClick={onClose}>
        Voltar
      </button>
      <h1 className="title-cp">Direitos Autorais</h1>
      <p className="section-title-cp"><strong>Comando Soluções em Segurança</strong></p>
      <p className="paragraph-cp">
        Todos os conteúdos, funcionalidades e serviços oferecidos pela aplicação desenvolvida por <strong>Comando Soluções em Segurança</strong> estão protegidos por leis de direitos autorais e outras leis de propriedade intelectual. Abaixo estão os termos e condições que regem o uso desses materiais:
      </p>
      
      <h2 className="section-title-cp">Propriedade Intelectual</h2>
      <p className="paragraph-cp">
        Todos os textos, gráficos, logotipos, ícones, imagens, clipes de áudio, downloads digitais, compilações de dados e software são de propriedade exclusiva da <strong>Comando Soluções em Segurança</strong> ou de seus licenciadores e são protegidos por leis de direitos autorais nacionais e internacionais.
      </p>
      <p className="paragraph-cp">
        A compilação de todo o conteúdo desta aplicação é de propriedade exclusiva da <strong>Comando Soluções em Segurança</strong> e protegida por leis de direitos autorais.
      </p>
      
      <h2 className="section-title-cp">Licença e Acesso</h2>
      <p className="paragraph-cp">
        A <strong>Comando Soluções em Segurança</strong> concede ao usuário uma licença limitada para acessar e fazer uso pessoal desta aplicação, mas não permite a modificação, reprodução, duplicação, cópia, venda, revenda, visita ou qualquer outro uso para fins comerciais sem o consentimento expresso por escrito da empresa.
      </p>
      <p className="paragraph-cp">
        Esta licença não inclui qualquer revenda ou uso comercial desta aplicação ou de seus conteúdos; qualquer coleta e uso de listas de produtos, descrições ou preços; qualquer uso derivado desta aplicação ou de seus conteúdos; qualquer download ou cópia de informações de conta para o benefício de outro comerciante; ou qualquer uso de mineração de dados, robôs ou ferramentas semelhantes de coleta e extração de dados.
      </p>
      
      <h2 className="section-title-cp">Marcas Registradas</h2>
      <p className="paragraph-cp">
        As marcas registradas, logotipos e marcas de serviço exibidos na aplicação são de propriedade da <strong>Comando Soluções em Segurança</strong> ou de terceiros. Os usuários não têm permissão para usar essas marcas sem a autorização prévia por escrito da <strong>Comando Soluções em Segurança</strong> ou do terceiro que detém a marca.
      </p>
      
      <h2 className="section-title-cp">Uso Indevido</h2>
      <p className="paragraph-cp">
        Qualquer uso não autorizado dos materiais contidos nesta aplicação pode violar leis de direitos autorais, leis de marcas registradas, leis de privacidade e publicidade, e outras regulamentações e estatutos. A <strong>Comando Soluções em Segurança</strong> reserva-se o direito de buscar todos os recursos disponíveis por lei em caso de violação destes termos.
      </p>
      
      <h2 className="section-title-cp">Isenção de Responsabilidade</h2>
      <p className="paragraph-cp">
        A <strong>Comando Soluções em Segurança</strong> não se responsabiliza por qualquer uso indevido dos materiais disponibilizados na aplicação por parte dos usuários. É de responsabilidade do usuário garantir que o uso dos materiais esteja em conformidade com as leis aplicáveis.
      </p>
      
      <h2 className="section-title-cp">Alterações nos Termos</h2>
      <p className="paragraph-cp">
        A <strong>Comando Soluções em Segurança</strong> reserva-se o direito de modificar estes termos de direitos autorais a qualquer momento. Quaisquer alterações serão publicadas nesta página e entrarão em vigor imediatamente após a publicação.
      </p>
      
      <div className="contact-info-cp">
        Para mais informações ou para solicitar permissões adicionais, entre em contato com a <strong>Comando Soluções em Segurança</strong> através dos canais de comunicação disponibilizados na aplicação.
        <br /><br />
        <strong>Comando Soluções em Segurança</strong><br />
        Av. Santos Dumont - 430, Ibiporã - PR, 86200-000<br />
        +55 (43) 3258-3608 <br />
        <a href="mailto:comandocameras@gmail.com">comandocameras@gmail.com</a>
      </div>
    </div>
  );
};

export default CopyrightComponent;
